import { render } from "./Digest.vue?vue&type=template&id=6b1e5378&scoped=true"
const script = {}

import "./Digest.vue?vue&type=style&index=0&id=6b1e5378&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6b1e5378"

export default script